export default "__VITE_ASSET__87962688__"